<template>
  <div :class="bem()">
    <VisionHeading
      :tag="sidebarData.sidebarPage.titleTag"
      :class="bem('page-title')"
      class="global-wrapper"
    >
      {{ sidebarData.sidebarPage.title }}
    </VisionHeading>
    <DatoStructuredText
      v-if="hasStructuredTextBodyContent"
      :content="sidebarData.sidebarPage.structuredTextBody"
      :class="bem('rich-text')"
      class="global-wrapper"
    />
  </div>
</template>

<script setup>
import sidebarGql from '@/gql/sidebar.gql'
import { isEmptyDocument } from 'datocms-structured-text-utils'

const bem = useBEM('DynamicPage')
const route = useRoute()
const { $sentry, $head } = useNuxtApp()

const { data: sidebarData, error } = await useDatoQuery({
  query: sidebarGql(route.meta.slug || route.params.slug),
})

if (error.value) {
  $sentry.captureException(error.value)
}

if (!sidebarData.value?.sidebarPage) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
    fatal: true
  })
}

const hasStructuredTextBodyContent = computed(() => {
  return !isEmptyDocument(sidebarData.value.sidebarPage.structuredTextBody)
})

useHead($head(sidebarData.value.sidebarPage.meta))
</script>

<style lang="postcss">
.DynamicPage__page-title {
  @apply mb-5 mt-5;
}

.DynamicPage__rich-text {
  h2 {
    @apply text-md mb-4 mt-10;
  }

  p {
    @apply text-sm mb-5;
  }
}
</style>
